export default __webpack_public_path__ + "static/media/homesl4.5c2c35a8.png";